import { render, staticRenderFns } from "./editBatch.vue?vue&type=template&id=00157bf3&"
import script from "./editBatch.vue?vue&type=script&lang=js&"
export * from "./editBatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports